import axios from 'axios';
import Vue from 'vue';

/**
 * @method connectBzbsGet
 * @method connectBzbsPost
 * @method connectBzbsGetฺBlob
 */
export default {
    /**
     * Connect Buzzebees GET method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data (optional)
     * @return Promise
     */
    connectBzbsGet: function (url, token, data) {
        var header = {
            'App-Id': Vue.bzbsConfig.app_id,
        };
        if (data == null) {
            data = {};
        }
        // data.device_app_id = this.config().client_id;
        if (token != null) {
            header.Authorization = 'token ' + token;
        }
        return axios({
            method: 'get',
            url: url,
            params: data,
            headers: header,
        });
    },

    /**
     * Connect Buzzebees POST method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data parameter
     * @return Promise
     */
    connectBzbsPost: function (url, token, data, uploadKey, uploadfile) {
        var header = {
            'App-Id': Vue.bzbsConfig.app_id,
        };
        // data.device_app_id = this.config().client_id;
        var form = this.arrToFormData(data);
        if (uploadKey)
            form.append(uploadKey, uploadfile);

        if (token != null) {
            header.Authorization = 'token ' + token;
        }

        return axios({
            method: 'post',
            url: url,
            data: form,
            headers: header,
        });
    },

    /**
     * Connect Buzzebees GET method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data (optional)
     * @return Promise
     */
    connectBzbsGetฺBlob: function (url, token, data) {
        if (data == null) {
            data = {};
        }
        // data.device_app_id = this.config().client_id;
        // if (token != null) {
        //     header.Authorization = 'token ' + token;
        // }
        return axios({
            method: 'get',
            url: url,
            params: data,
            headers: null,
        });
    },

    arrToFormData: function (arr) {
        var form = new FormData();
        for (var i in arr) {
            form.append(i, arr[i]);
        }
        return form;
    },

    /**
     * Connect Buzzebees DELETe method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data (optional)
     * @return Observable
     */
    connectBzbsDelete: function (url, token, data) {
        return this.connectMethod(url, token, data, 'delete');
    },

    /**
     * Connect Buzzebees with Method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data (optional)
     * @param {string} method (required) get, delete
     * @return Observable
     */
    connectMethod: function (url, token, data, method) {
        var header = {
            'App-Id': Vue.bzbsConfig.app_id,
        };
        if (data == null) {
            data = {};
        }
        if (token != null) {
            header.Authorization = 'token ' + token;
        }

        return axios({
            method: method,
            url: url,
            params: data,
            headers: header,
        });
    },
}
